<template>
  <div>
    <div class="flex-between">
      <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="提现搜索：" prop="name">
          <el-input v-model="searchForm.name" placeholder="请输入订单号/用户昵称/手机号搜索" class="mt-search-width"></el-input>
        </el-form-item>
        <el-form-item label="时间筛选：" prop="date">
          <el-date-picker
            v-model="searchForm.date"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
          <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          <el-button style="margin-left: 24px;" @click="exportExcelBtn">数据导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      border
      :data="infoList">
      <el-table-column
        align="center"
        prop="id"
        label="ID">
      </el-table-column>
      <el-table-column
        align="center"
        prop="nickName"
        label="昵称">
      </el-table-column>
      <el-table-column
        align="center"
        prop="phone"
        label="手机号">
      </el-table-column>
      <el-table-column
        align="center"
        prop="cashMoney"
        label="提现金额">
      </el-table-column>
      <el-table-column
        align="center"
        prop="applyType"
        label="提现方式">
        <template slot-scope="scope">
          <span>{{scope.row.applyType == 1 ? '银行提现' : '支付宝提现'}}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="applyCardNo"
        label="提现账号">
      </el-table-column>
      <el-table-column
        align="center"
        prop="money"
        label="提现余额">
      </el-table-column>
      <el-table-column
        align="center"
        prop="updateTime"
        label="申请时间">
      </el-table-column>
      <el-table-column
        v-if="tabCurrent == 2"
        align="center"
        prop="auditFailReason"
        label="备注">
      </el-table-column>
      <el-table-column
        v-if="tabCurrent == 0"
        align="center"
        width="240"
        label="操作">
        <template slot-scope="scope">
          <el-button @click="examineOpenBtn(scope.row.id)" type="text" size="small">审核</el-button>
        </template>
      </el-table-column>
      <el-table-column
        v-if="tabCurrent == 1"
        align="center"
        width="240"
        label="操作">
        <template slot-scope="scope">
          <el-button @click="uploadCertificateOpenBtn(scope.row.id)" type="text" size="small">上传凭证</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="mt-page-bottom flex-end-row">
      <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
    </div>
    <!-- 审核弹窗 -->
    <el-dialog
      title="审核"
      :visible.sync="examineShow"
      width="960px">
      <el-form :model="examineForm" label-width="140px">
        <el-form-item label="审核意见：">
          <el-radio-group v-model="examineForm.status">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="3">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="examineForm.status == 3" label="">
          <el-input rows="5" style="width: 420px;" type="textarea" v-model="examineForm.auditFailReason" placeholder="请输入驳回理由"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="examineSaveBtn">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 上传凭证弹窗 -->
    <el-dialog
      title="上传凭证"
      :visible.sync="uploadCertificateShow"
      width="960px">
      <el-form label-width="140px">
        <el-form-item label="上传凭证：">
          <el-upload
            :action="baseUrl+'/system/common/upload/uploadFile'"
            list-type="picture-card"
            :headers="{'Authorization': token}"
            :multiple="false"
            :limit="1"
            :file-list="fileList"
            :on-remove="delImgBtn"
            :on-success="uploadImgBtn">
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip">若需要更换图片，请先删除原图片</div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="uploadCertificateSaveBtn">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { queryUserCommissionWithdrawalApplyLogPageList, updateUserCommissionWithdrawalApplyLog, uploadPaymentImage, exportExcel } from '@/api/finance'
export default {
  name: 'SingleOne',
  props: {
    tabCurrent: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      baseUrl:this.$baseUrl,
      token:this.$token,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      infoId: '',
      fullscreenLoading: false,
      searchForm: {
        name: '',
        date: ['', '']
      },
      // 审核弹窗
      examineShow:false,
      examineForm:{
        status:1,
        auditFailReason:''
      },
      // 上传凭证弹窗
      uploadCertificateShow:false,
      fileList:[],
      uploadCertificateImg:''
    }
  },
  watch: {
    "tabCurrent"(newVal, oldVal) {
      this.currentPage = 1;
      this.getInfoList();
    }
  },
  mounted () {
    let token = sessionStorage.getItem('token')
    if (!token) {
      token = ''
    }
    this.token = token;
    this.currentPage = 1;
    this.getInfoList();
  },
  methods: {
    // 导出操作
    exportExcelBtn(){
      var that = this;
      let searchName = that.searchForm.name
      let tabCurrent = that.tabCurrent
      let startDate = ''
      let endDate = ''
      if (that.searchForm.date !== null) {
        startDate = that.searchForm.date[0]
        endDate = that.searchForm.date[1]
      }
      exportExcel({ webSearchStr: searchName, startCreateDate:startDate, endCreateDate:endDate,status:tabCurrent }).then((res) => {
          // 处理二进制数据并创建 Blob 对象
          const blobObj = new Blob([res], { type: 'application/octet-stream' });
          // 创建一个链接并设置下载属性
          const downloadLink = document.createElement("a");
          let url = window.URL || window.webkitURL || window.moxURL; // 兼容不同浏览器的 URL 对象
          url = url.createObjectURL(blobObj);
          downloadLink.href = url;
          downloadLink.download = '财务列表'+new Date().getTime()+'.xlsx'; // 设置下载的文件名
          // 将链接添加到 DOM 中，模拟点击
          document.body.appendChild(downloadLink);
          downloadLink.click();
          // 移除创建的链接和释放 URL 对象
          document.body.removeChild(downloadLink);
          window.URL.revokeObjectURL(url);
      })
    },
    /* 审核弹窗-打开操作 */
    examineOpenBtn(infoId){
      this.infoId = infoId;
      this.examineShow = true;
    },
    /* 审核弹窗-保存操作 */
    examineSaveBtn(){
      var infoId = this.infoId;
      var examineForm = this.examineForm;
      examineForm.id = infoId;
      var that = this;
      updateUserCommissionWithdrawalApplyLog(examineForm).then((res) => {
        if (res.errorCode === '0000') {
          that.examineForm.status = 1;
          that.examineForm.auditFailReason = '';
          that.examineShow = false;
          that.getInfoList();
          that.$messge.success(res.msg);
        }
        if (res.errorCode === '1001') {
          that.$messge.error(res.msg);
        }
      })
    },
    // 上传凭证弹窗-打开操作
    uploadCertificateOpenBtn(infoId){
      this.infoId = infoId;
      this.uploadCertificateShow = true;
    },
    /* 上传图片 */
    uploadImgBtn(file){
      this.uploadCertificateImg = file.data.fileUrl
    },
    /* 删除上传的图片 */
    delImgBtn(file,fileList){
      var icon = '';
      fileList.forEach(function(item){
        icon = item.url;
      });
      this.uploadCertificateImg = icon;
    },
    // 上传凭证弹窗-保存操作
    uploadCertificateSaveBtn(infoId){
      var infoId = this.infoId;
      var uploadCertificateImg = this.uploadCertificateImg;
      if(uploadCertificateImg == ''){
        this.$message.error('请上传凭证');
        return false;
      }
      var that = this;
      uploadPaymentImage({id: infoId, paymentImg: uploadCertificateImg}).then((res) => {
        that.fullscreenLoading = false
        if (res.errorCode === '0000') {
          this.$message({
            message: res.msg,
            type: 'success',
            onClose () {
              that.uploadCertificateShow = false;
              that.getInfoList()
            }
          })
        }
        if (res.errorCode === '1001') {
          this.$message.error(res.msg)
        }
      })
    },
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let tabCurrent = that.tabCurrent
      let startDate = ''
      let endDate = ''
      if (that.searchForm.date !== null) {
        startDate = that.searchForm.date[0]
        endDate = that.searchForm.date[1]
      }
      let page = that.currentPage
      queryUserCommissionWithdrawalApplyLogPageList({ webSearchStr: searchName, startCreateDate:startDate, endCreateDate:endDate, status: tabCurrent, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/finance/components/SingleOne.vue